import { FILE_ICONS, closeLoading, openLoading } from 'gf-ui'
import prettyBytes from 'pretty-bytes'
import React, { useCallback, useState } from 'react'
import { Button, Form, Image } from 'react-bootstrap'
import { useDropzone } from 'react-dropzone'
import { FaPaperclip } from 'react-icons/fa'
import { useDispatch } from 'react-redux'

/**
 * <a href="https://www.flaticon.com/free-icons/pdf" title="pdf icons">Pdf icons created by Smashicons - Flaticon</a> 
 */

const UpdateFile = ({onSelectFiles}) => {
  const dispatch = useDispatch()
  const [allegati, setAllegati] = useState([])  

  const updateAllegati = useCallback( files => {
    let _allegati = [...allegati]   
    _allegati = _allegati.concat(files)    
    setAllegati([..._allegati]);      
    onSelectFiles(_allegati)
  }, [allegati, setAllegati, onSelectFiles])
  
  const onDrop = useCallback(acceptedFiles => {        
    let _allegati = []
    acceptedFiles.forEach(file => {      
      openLoading(dispatch)
      const reader = new FileReader();         
      reader.onload = (event) => {        
        let allegato = {};
        allegato['path']=file.path;
        allegato['size']=file.size;
        allegato['type']=file.type;                  
        allegato['base64'] = event.target.result;
        _allegati.push(allegato)      
        updateAllegati(_allegati);
        closeLoading(dispatch)
      };      
      reader.readAsDataURL(file);                        
    });        
  }, [dispatch, updateAllegati])
  
  const {getRootProps, getInputProps} = useDropzone({onDrop, accept: {
    'image/jpg': ['.jpg', '.jpeg'],
    'image.png': ['.png'],
    'application/zip': ['.zip'],    
    'application/pdf': ['.pdf']
  }})  
  
  const props = {
    className: 'dropzone bg-light p-2 border rounded text-center text-secondary'
  }

  const eliminaAllegato = (index) => {
    let _allegati = [...allegati]
    _allegati.splice(index, 1)
    setAllegati(_allegati)
    onSelectFiles(_allegati)
  }  
    
  return (
    <>
      <section>
        <Form.Label><FaPaperclip /> Allegati</Form.Label>
        <div {...getRootProps(props)}>
          <input {...getInputProps()} />
          <span>Trascina qui il file, oppure fai click per selezionarlo</span>
          <span>Tipi file accettati: Immagini (jpg, png) o Pdf</span>
        </div>
        { allegati.length>0 && (
        <aside>          
          <div className='d-flex flex-row flex-wrap align-items-center justify-content-start bg-light mt-2 p-2 border rounded'>
            { allegati && allegati.map( (allegato, index) => 
              <div key={allegato.path} className="animate__animated animate__flash border rounded bg-white m-2 p-2 d-flex flex-column align-items-center justify-content-start" style={{ width: '137px', height: '180px'}}>
                <>
                  { allegato.type.indexOf('image')>=0 && (
                    <div className='flex-grow-1 d-flex flex-column align-items-center justify-content-center'>
                      <Image src={allegato.base64} alt={allegato.path} title={allegato.path} className="allegato-image" />
                    </div>
                  )}                
                  { allegato.type.indexOf('pdf')>=0 && (
                    <div className='flex-grow-1 d-flex flex-column align-items-center justify-content-center'>
                      <Image src={FILE_ICONS.pdf} alt={allegato.path} title={allegato.path} className="allegato-image" />
                    </div>
                  )}                
                  {(allegato.type.indexOf('compressed') >= 0 || allegato.type.indexOf('application/zip') >= 0) && (
                    <div className='flex-grow-1 d-flex flex-column align-items-center justify-content-center'>
                      <Image src={FILE_ICONS.zip} alt={allegato.path} title={allegato.path} className="allegato-image" />
                    </div>
                  )}
                  <div className='text-center'><small>{prettyBytes(allegato.size)}</small></div>
                  <Button variant="link" className="text-danger" onClick={()=>eliminaAllegato(index)}>elimina</Button>
                </>
              </div>
            )}
          </div>
        </aside>
        )}
      </section>      
    </>
  )
}

export default UpdateFile